// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { _getUrl } from '../api/utils';

/** Feature flag key for the EAMC chatbot integration. */
export const CHATBOT_FEATURE_FLAG = 'ENABLE_EAMC_CHATBOT' as const;

/**
 * Resolve the chatbot BFF base URL for the given tenant.
 *
 * Priority:
 * 1. `VITE_EAMC_CHATBOT_BFF_URL` env override (local/dev smoke testing).
 * 2. Host-derived URL: same `<tenant>.sys.<env>.imprivata.cloud` gateway used by
 *    `getApiUrl`, with the `/eamc-chat` path suffix.
 *
 * Non-local/non-dev environments stay flag-off until BFF URLs are published
 * .
 */
export function getChatbotBffBaseUrl(tenantId?: string | null): string {
  const override = import.meta.env.VITE_EAMC_CHATBOT_BFF_URL as string | undefined;
  if (override) {
    return override;
  }

  const host = tenantId ?? 'astra';
  const urls = _getUrl({ apiUrl: { sub: `${host}.sys` } });
  const apiUrl = urls?.apiUrl;
  if (!apiUrl) {
    throw new Error(
      `getChatbotBffBaseUrl: could not derive BFF URL for tenant "${host}". ` +
        'Set VITE_EAMC_CHATBOT_BFF_URL to override.',
    );
  }
  return `${apiUrl}/eamc-chat`;
}
